import { render, staticRenderFns } from "./AnonymisationPage.vue?vue&type=template&id=11ce374e&scoped=true"
import script from "./AnonymisationPage.vue?vue&type=script&lang=js"
export * from "./AnonymisationPage.vue?vue&type=script&lang=js"
import style0 from "./AnonymisationPage.vue?vue&type=style&index=0&id=11ce374e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ce374e",
  null
  
)

export default component.exports